
import getRandomNumber from "./get-random-number-in-range";
import { setBoolItem, getBoolItem } from "./storage-crud";
import { NUMBER } from "../../constants/app-constants";

const showFeature = (featureName, percentageRollout) => {
    let showFeatureFlag = getBoolItem(featureName);
    const number = getRandomNumber(NUMBER.ONE, NUMBER.HUNDRED);

    if (showFeatureFlag !== undefined && showFeatureFlag !== null) {
        return showFeatureFlag;
    } else if (number <= percentageRollout) {
        showFeatureFlag = true;
    } else {
        showFeatureFlag = false;
    }

    setBoolItem(showFeatureFlag, featureName);
    return showFeatureFlag;
};

export default showFeature;
